import React, { useState } from 'react';
import { Grid, Button, Container, CssBaseline, FormControl, InputLabel, TextField, MenuItem, Select, Typography, Card, Input, CardContent, CardMedia } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppGPT = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const theme = useTheme();
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e) => {
    // Check if a file is selected
    if (e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const fileInput = document.getElementById('whatsapp_text');

    if (fileInput.files[0]) {
      formData.append('file', fileInput.files[0]);
    }

    // Append the question to the FormData instance
    formData.append('question', question);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/universal-gpt/whatsapp`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setAnswer(data.answer.response);
        console.log(data.answer.response);
      } else {
        console.error('Request failed');
      }
    } catch (error) {
      console.error('Request failed', error);
    }
  };

  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>
      <Navbar />
      <Grid container direction="row" style={{ height: '100%' }}>
        <Grid item xs={2} sm={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={10} sm={10} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Grid item xs={6} sm={6}>
            <Card variant="outlined" style={{ height: '600px', marginTop: "20px", marginLeft: "20px", marginRight: "20px" }}>
              <CardContent>
                <WhatsAppIcon sx={{ fontSize: 40 , color:"green"}}/>
                <br></br>
                <br></br>
                <Typography variant="body2" color="text.secondary" fontSize="20px">
                  Instructions:
                  <ol>
                    <li>Export a Whatsapp chat.</li>
                    <ul>
                      <li>Open a Chat</li>
                      <li>Tap on the menu > More > Export chat</li>
                      <li>Select Without media</li>
                      <li>Save the .txt file in your computer</li>
                    </ul>
                    <li>Upload the file in the form on the right.</li>
                    <li>Write a question related to your Whatsapp chat and hit submit.</li>
                  </ol>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6}>

            <Card variant="outlined" style={{ height: '600px', marginTop: "20px", marginRight: "20px" }}>
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <InputLabel htmlFor="whatsapp_text" variant="body2" fontSize="20px">Upload Whatsapp text file</InputLabel>
                  <br></br>
                  <input
                    type="file"
                    id="whatsapp_text"
                    onChange={handleFileChange} // <-- Set the handleFileChange function to be called when the file input changes
                  />
                  <br></br>
                  <br></br>
                  <InputLabel htmlFor="question" variant="body2" fontSize="20px">Question</InputLabel>

                  <input type="text" id="question" value={question} onChange={e => setQuestion(e.target.value)} style={{ width: "100%", height: "50%" }} />
                  <br></br>
                  <br></br>
                  <button type="submit">Submit</button>
                  <br></br>
                  <br></br>
                </form>
                <div>
                  <Typography variant="body2" color="text.secondary" fontSize="15px">File: {fileName}</Typography>
                  {/* <-- Display the file name */}
                  <br />
                  <Typography variant="body2" color="text.secondary" fontSize="15px">Answer:</Typography>
                  <textarea id="freeform" name="freeform" rows="4" cols="50" value={answer} style={{ width: "100%", height: "320px", overflow: "auto" }}></textarea>
                </div>

              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>

    </div>
  );
};

export default WhatsAppGPT;

